import { render } from "./Richieste.vue?vue&type=template&id=084db7c2&scoped=true&ts=true"
import script from "./Richieste.vue?vue&type=script&lang=ts"
export * from "./Richieste.vue?vue&type=script&lang=ts"

import "./Richieste.vue?vue&type=style&index=0&id=084db7c2&scoped=true&lang=css"

import exportComponent from "/Users/andrea/Sites/app_v2/app_mmx/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-084db7c2"]])

export default __exports__